import create from 'zustand';
import {
  BaseCaptureSlice,
  CaseDataSlice,
  ModalSlice,
  SettingsSlice,
  TimelineSlice,
  TouchDeviceSlice,
  createBaseCaptureSlice,
  createCaseDataSlice,
  createModalSlice,
  createSettingsSlice,
  createTimelineSlice,
  createTouchDeviceSlice
} from './slices';
import { ValidateTreatmentSlice, createValidateTreatmentSlice } from './slices/validateTreatmentSlice';

/* eslint-disable */
export type CommonBoundState = ModalSlice &
  TouchDeviceSlice &
  SettingsSlice &
  CaseDataSlice &
  TimelineSlice &
  BaseCaptureSlice &
  ValidateTreatmentSlice;
/* eslint-enable*/

export const useCommonBoundStore = create<CommonBoundState>()((...a) => ({
  ...createModalSlice(...a),
  ...createTouchDeviceSlice(...a),
  ...createSettingsSlice(...a),
  ...createCaseDataSlice(...a),
  ...createTimelineSlice(...a),
  ...createBaseCaptureSlice(...a),
  ...createValidateTreatmentSlice(...a)
}));
